export const APP_VERSION = 'v1.2.0';